import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ctaboxtwo',
  templateUrl: './ctaboxtwo.component.html',
  styleUrls: ['./ctaboxtwo.component.scss']
})
export class CtaboxtwoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
